const Globe01 = ({ size, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "17"}
      height={size || "17"}
      viewBox="0 0 17 17"
      fill="none"
    >
      <g id="globe-01">
        <path
          id="Solid"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.46466 1.0498C12.5148 1.0498 15.798 4.33305 15.798 8.38314C15.798 12.4332 12.5148 15.7165 8.46466 15.7165C4.41457 15.7165 1.13133 12.4332 1.13133 8.38314C1.13133 4.33305 4.41457 1.0498 8.46466 1.0498ZM2.50128 7.71647C2.77667 5.2253 4.5772 3.19379 6.94847 2.57636C5.93073 4.10609 5.31419 5.87435 5.16472 7.71647H2.50128ZM2.50128 9.04981C2.77667 11.541 4.5772 13.5725 6.94847 14.1899C5.93073 12.6602 5.31419 10.8919 5.16472 9.04981H2.50128ZM9.98086 14.1899C12.3521 13.5725 14.1527 11.541 14.428 9.04981H11.7646C11.6151 10.8919 10.9986 12.6602 9.98086 14.1899ZM14.428 7.71647H11.7646C11.6151 5.87435 10.9986 4.10609 9.98086 2.57636C12.3521 3.19379 14.1527 5.2253 14.428 7.71647ZM8.46466 2.75034C9.57778 4.18443 10.2588 5.90769 10.4263 7.71647H6.50306C6.67052 5.90769 7.35154 4.18443 8.46466 2.75034ZM8.46466 14.0159C7.35154 12.5818 6.67052 10.8586 6.50306 9.04981H10.4263C10.2588 10.8586 9.57778 12.5818 8.46466 14.0159Z"
          fill={color || "#E31B54"}
        />
      </g>
    </svg>
  );
};

export default Globe01;
